export default [
  { id: 'activityId', label: 'Activity ID' },
  { id: 'amountMinutes', label: 'Amount Minutes' },
  { id: 'date', label: 'Date' },
];